import React, {Component} from 'react';

const TableHead = ({onCheck, onSort}) => (
  <thead>
    <tr className="cc-table-row cc-table-row--header">
      <th><input type="checkbox" name="checkAll" value="check" onClick={e => onCheck(e)} /></th>
      <th data-sort="id" onClick={() => onSort("id")}>ID</th>
      <th data-sort="surname" onClick={() => onSort("surname")}>Imię i nazwisko</th>
      <th onClick={() => onSort("index")}>Indeks</th>
      <th onClick={() => onSort("mail")}>E-mail</th>
      <th onClick={() => onSort("department")}>Wydział</th>
      <th onClick={() => onSort("statusStudent")}>Status</th>
      <th onClick={() => onSort("paymentsinfo")}>Płatność</th>
      <th onClick={() => {}}>Zgłaszający</th>
      <th onClick={() => {}}>Partner</th>
      <th>Wysłane</th>
      <th>Opcje</th>
    </tr>
  </thead>
)

const TableRow = ({ lp ,id, firstName, surname, index, mail, isIzet, status, payment, mails, partnerOf, hasPartner, onClick}) => (
  <tr className="cc-table-row"
    onClick={(e) => onClick(e, id)}
  >
    <td><input type="checkbox" name="listCheck" value={id} data-action="check"/></td>
    <td>{lp}</td>
    <td>{`${firstName} ${surname}`}</td>
    <td>{index}</td>
    <td>{mail}</td>
    {/* <td>{department}</td> */}
    <td>{isIzet === 'true' ? 'W8' : 'inny'}</td>
    <td>{status}</td>
    <td>{payment}</td>
    <td>{partnerOf ? `${partnerOf.firstName} ${partnerOf.surname}` : '-'}</td>
    <td>{hasPartner ? `${hasPartner.firstName} ${hasPartner.surname}` : '-'}</td>
    <td className="cc-table-row--mails">{
      mails.map((mail, i) =>
        <span key={i}>{mail.type}</span>
      )
    }</td>
    <td>
      <i className="material-icons ico-btn"
        data-action="delete"
      >delete</i>
    </td>
  </tr>
);

export default class StudentsTable extends Component {
  state = {
    data: this.props.data,
    checked: [],
    lastChecked: 0
  }

  handleClick = (e, id) => {
    // const id = e.currentTarget.dataset.id;
    const action = e.target.dataset.action;
    if (action === 'delete') {
      this.props.onDelete(id);
    } else if (action === 'check') {
      let clicked = 0;
      const checkboxes = [...this.dataTable.querySelectorAll('input[name="listCheck"]')];
      for (let i=0; i < checkboxes.length; ++i) {
        if (checkboxes[i] == e.target) {
          clicked = i;
          break;
        }
      }
      if ( e.shiftKey ) {
        for (let i = this.state.lastChecked; i <= clicked; ++i) {
          checkboxes[i].checked = true;
        }
      }

      this.setState({
        lastChecked: clicked,
        checked: [...this.dataTable.querySelectorAll('input[name="listCheck"]:checked')]
      });
      return;
    } else {
      this.props.onEdit(id);
    }
  }

  handleCheckAll = (e) => {
    const checked = e.target.checked;
    [...this.dataTable.querySelectorAll('input[name="listCheck"]')].forEach( input => input.checked = checked);
    this.setState({
      lastChecked: !checked ? 0 : this.state.lastChecked,
      checked: [...this.dataTable.querySelectorAll('input[name="listCheck"]:checked')]
    });
  }

  handleMailSending = () => {
    const data = [...this.dataTable.querySelectorAll('input[name="listCheck"]')].filter( input => input.checked);
    console.log(data.length);
    this.props.onMailCreating(data.length ? data.map(e => e.value) : []);
  }

  handleGroupEdit = () => {
    const data = [...this.dataTable.querySelectorAll('input[name="listCheck"]')].filter( input => input.checked);
    this.props.onGroupEdit(data.length ? data.map(e => e.value) : []);
  }

  handleGroupDelete = () => {
    const data = [...this.dataTable.querySelectorAll('input[name="listCheck"]')].filter( input => input.checked);
    this.props.onGroupDelete(data.length ? data.map(e => e.value) : []);
  }

  sortData = (sortBy) => {
    const data = this.state.data.sort( (a, b) => {
      if (a[sortBy] > b[sortBy])
        return 1;
      if (a[sortBy] < b[sortBy])
        return -1;
      return 0;
    });
    this.setState({data});
  }

  render() {
    const { title, onSort } = this.props;
    const { data } = this.state;
    return (
      <div className="container">
        <h2 className="cc-table-title">{title}</h2>
        <span style={{'display': 'flex'}}>
          <button onClick={this.handleMailSending} className="cc-button">Wyslij maile do zaznaczonych <b>{this.state.checked.length}</b></button>
          <button onClick={this.handleGroupEdit} className="cc-button">Edytuj zaznaczonych <b>{this.state.checked.length}</b></button>
          <button onClick={this.handleGroupDelete} className="cc-button">Usun zaznaczonych <b>{this.state.checked.length}</b></button>
        </span>
        <table className="cc-table">
          <TableHead onCheck={this.handleCheckAll} onSort={this.sortData} />
          <tbody ref={n=>this.dataTable = n}>
          {
            this.props.data.map((e, i) =>
            <TableRow
              key={i}
              id={e._id}
              lp={e.id}
              firstName={e.firstName}
              surname={e.surname}
              index={e.index}
              mail={e.mail}
              isIzet={e.isIzet}
              status={e.statusStudent}
              payment={e.paymentsInfo}
              mails={e.sendMails || []}
              onClick={this.handleClick}
              hasPartner={e.hasPartner}
              partnerOf={e.partnerOf}
            />
          )}
          </tbody>
        </table>
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/modules/Admin/components/StudentsTable.js